import Vue from 'vue'
import stateInfo from "./stateInfo.vue";

const PopupBox = Vue.extend(stateInfo);

stateInfo.install = function (data) {
  let instance = new PopupBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
};

export default stateInfo



// WEBPACK FOOTER //
// ./src/components/popup/stateInfo.js